export default __webpack_public_path__ + "static/media/HMM.a38af901.png";